export default __webpack_public_path__ + "static/media/cc781a545e3d4fbb548523e37254ae91.bfd899d1.svg";